'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  language: 'en' | 'es';
}

const HeroSection = ({ language }: HeroSectionProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const content = {
    en: {
      headline: 'Efficiency Is Luxury',
      subhead: 'Clear legal solutions for founders who have no time to waste.',
      cta: 'Book a Call'
    },
    es: {
      headline: 'La Eficiencia Es Lujo',
      subhead: 'Soluciones legales claras para fundadores que no tienen tiempo que perder.',
      cta: 'Agendar Llamada'
    }
  };

  return (
    <section className="pt-32 pb-20 px-6">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div className={`space-y-8 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
            <h1 className="text-6xl lg:text-7xl font-bold tracking-tight text-foreground leading-[0.95]">
              {content[language].headline}
            </h1>
            <p className="text-xl text-muted-foreground max-w-lg leading-relaxed">
              {content[language].subhead}
            </p>
            <Link
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-primary-foreground bg-primary sharp hover:scale-105 transition-transform duration-300">
              
              {content[language].cta}
            </Link>
          </div>

          {/* Right: Visual */}
          <div className={`relative h-[500px] ${isVisible ? 'animate-fadeInScale delay-200' : 'opacity-0'}`}>
            <div className="absolute inset-0 bg-gradient-to-br from-muted to-secondary sharp overflow-hidden">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_18dbf3c6d-1767148747773.png"
                alt="Modern office building in Toronto representing professional legal services"
                className="w-full h-full object-cover opacity-20" />
              
              {/* Floating Metric Widget */}
              <div className="absolute bottom-8 left-8 right-8 glass-panel p-6 sharp border hairline border-border">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm font-semibold text-foreground">Response Time</span>
                  <span className="font-mono text-2xl font-bold text-primary">&lt;24h</span>
                </div>
                <div className="h-2 bg-muted sharp overflow-hidden">
                  <div className="h-full w-full bg-primary sharp animate-fadeInScale delay-500" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;